"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _route = _interopRequireDefault(require("./route"));

/**
 * Public route - when path is will just be visible
 *
 * @class PublicRoute
 * @extends {Component}
 */
var PublicRoute =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PublicRoute, _Component);

  function PublicRoute() {
    (0, _classCallCheck2["default"])(this, PublicRoute);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PublicRoute).apply(this, arguments));
  }

  (0, _createClass2["default"])(PublicRoute, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_route["default"], (0, _extends2["default"])({
        checkAuthentication: false
      }, this.props));
    }
  }]);
  return PublicRoute;
}(_react.Component);

var _default = PublicRoute;
exports["default"] = _default;